const CustomTypeModelSliceType = {
  Slice: "Slice",
  SharedSlice: "SharedSlice"
};
export {
  CustomTypeModelSliceType
};
//# sourceMappingURL=sliceZone.js.map
